import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import {
  RunRatingRequest,
  RunRatingService,
  RunRatingState,
  SavedRunRating,
} from '@infinitform/platform-core';
import { CLOUD_PLATFORM_CONFIG } from '../config';

@Injectable()
export class CloudRunRatingService implements RunRatingService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(CLOUD_PLATFORM_CONFIG);

  // Errors are left as HttpErrorResponse: the caller tells a 409 (results
  // changed) from a 403 (not enabled) by status.
  rate({ projectId, ...body }: RunRatingRequest): Promise<SavedRunRating> {
    return lastValueFrom(
      this.http.post<SavedRunRating>(
        `${this.config.apiBaseUrl}/project/${projectId}/ratings`,
        body
      )
    );
  }

  current(projectId: string): Promise<RunRatingState> {
    return lastValueFrom(
      this.http.get<RunRatingState>(
        `${this.config.apiBaseUrl}/project/${projectId}/rating`
      )
    );
  }
}
